/**
 * Copy object with completely new reference address
 * @param {object} obj
 */
export const copyObject = (obj) => JSON.parse(JSON.stringify(obj));
